import { PasswordInput } from '@frontend/components/basic-forms';
import { useBrandingRepository } from '@frontend/repository';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import defaultLogo from '../../../../../assets/images/telloport_logo_horizontal.png';
import { ConfirmationComponent } from '../../basic-sign-up/basic-sign-up-confirmation/basic-sign-up-confirmation.component';
import useForgotPasswordConfirmation from './forgot-password-confirmation.controller';

const ID = 'forgot-password-confirmation';

const ForgotPasswordConfirmation = () => {
    const viewProps = useForgotPasswordConfirmation();
    const { logo_navbar_expanded } = useBrandingRepository();

    const logo = useMemo(() => {
        if (logo_navbar_expanded) return logo_navbar_expanded;
        return defaultLogo;
    }, [logo_navbar_expanded]);

    return (
        <div
            id={ID}
            className='relative flex h-screen w-screen flex-col'>
            <div className='bg-brand-structure absolute top-0 right-0 left-0 -z-1 h-[40vh] w-full' />
            <form className='bg-always-white mx-auto my-40 h-1/2 w-1/2 rounded-lg shadow-lg'>
                <div className='flex h-1/3 flex-col justify-center p-3 align-middle'>
                    <img
                        src={logo}
                        className='img-fluid m-auto w-30'
                    />
                    <h1 className='text-brand-primary m-auto text-4xl font-black'>
                        <FormattedMessage
                            id='forgot-password-confirmation.title'
                            description='Title for the forgot password confirmation page.'
                            defaultMessage='Reset password'
                        />
                    </h1>
                </div>

                {viewProps.response ? (
                    <div className='flex h-1/2 w-full flex-col content-center items-center p-4'>
                        <ConfirmationComponent
                            submitted={viewProps.submitted}
                            response={viewProps.response}
                        />
                    </div>
                ) : (
                    <>
                        <div className='flex h-1/3 w-full flex-col content-center items-center p-4'>
                            <PasswordInput
                                required
                                label={
                                    <FormattedMessage
                                        id='forgot-password-confirmation.new-password'
                                        description='Label for the new password field.'
                                        defaultMessage='New password'
                                    />
                                }
                                value={viewProps.newPassword}
                                onChange={(value) => viewProps.changeNewPassword(value)}
                                isValidCallback={(value) => {
                                    viewProps.changePasswordValid(value);
                                }}
                                strength
                            />
                            <PasswordInput
                                id='confirm'
                                required
                                label={
                                    <FormattedMessage
                                        id='forgot-password-confirmation.confirm-new-password'
                                        description='Label for the confirm new password field.'
                                        defaultMessage='Confirm new password'
                                    />
                                }
                                value={viewProps.repeatPassword}
                                onChange={(value) => viewProps.changeRepeatPassword(value)}
                                isValidCallback={(value) => {
                                    viewProps.changePasswordConfirmationValid(value);
                                }}
                                toRepeat={viewProps.newPassword}
                            />
                        </div>
                        <div className='flex h-1/3 w-full flex-col items-center justify-end gap-3 pb-4'>
                            <button
                                id='reset-password-button'
                                type='submit'
                                onClick={viewProps.onSubmit}
                                className='bg-brand-primary inline-flex w-1/3 cursor-pointer items-center justify-center rounded-md px-4 py-3'
                                disabled={!viewProps.passwordValid || !viewProps.passwordConfirmationValid || viewProps.submitted}
                                data-testid='resetPasswordButton'>
                                <div className='text-always-white justify-start text-base font-medium'>
                                    <FormattedMessage
                                        id='forgot-password-confirmation.title'
                                        description='Title for the forgot password confirmation page.'
                                        defaultMessage='Reset password'
                                    />
                                </div>
                            </button>
                        </div>
                    </>
                )}
            </form>
        </div>
    );
};

export default ForgotPasswordConfirmation;
